var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDailyTraining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.971,
    height: 27.396,
    viewBox: "0 0 23.971 27.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-graduate",
    "data-name": "Icon awesome-user-graduate",
    d: "M17.09,17.154l-5.1,5.1-5.1-5.1A7.175,7.175,0,0,0,0,24.313v.514a2.569,2.569,0,0,0,2.568,2.568H21.4a2.569,2.569,0,0,0,2.568-2.568v-.514a7.175,7.175,0,0,0-6.881-7.159ZM.728,4.269l.342.08V7.474a1.236,1.236,0,0,0-.048,2.14L.187,12.948C.1,13.317.3,13.7.594,13.7H2.83c.294,0,.5-.38.407-.749L2.4,9.615a1.236,1.236,0,0,0-.048-2.14V4.66l3.531.851a6.836,6.836,0,1,0,12.948,3.05,6.727,6.727,0,0,0-.749-3.05l5.153-1.241a.851.851,0,0,0,0-1.685L13.05.123a4.6,4.6,0,0,0-2.124,0L.728,2.579A.855.855,0,0,0,.728,4.269Z",
    transform: "translate(0 0.002)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDailyTraining);
export default __webpack_public_path__ + "static/media/icon-daily-training.c81b9eae542f621eb047237d74f0783b.svg";
export { ForwardRef as ReactComponent };